<template>
    <div class="bg-gray-100">
        <TopLocationHero
            static-image-key="bird-friendly-learning-trail___hero"
            title-key="bird_friendly_learning_trail.title"
        />

        <div class="relative mt-4 sm:mt-12 z-1">
            <a id="main-content" class="fixed top-0" tabindex="-1"></a>

            <div class="container hidden sm:block">
                <Breadcrumb :items="breadcrumbItems" />
            </div>

            <TopLocationBackgroundShape1 />
        </div>

        <div class="container relative z-2 mt-12">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- INTRO -->
            <!-- * -->
            <Type3Block
                featured
                title-key="bird_friendly_learning_trail.intro.title"
                description-key="bird_friendly_learning_trail.intro.description"
                details-title-key="bird_friendly_learning_trail.intro.details_title"
                details-description-key="bird_friendly_learning_trail.intro.details_description"
                static-image-key="bird-friendly-learning-trail___intro"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- 120+ BIRD TYPES IN LIGET -->
            <!-- * -->
            <Type8Block
                title-key="bird_friendly_learning_trail.bird_types.title"
                description-key="bird_friendly_learning_trail.bird_types.description"
                class="relative z-2 mt-16 sm:mt-20"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- BIRD SOUND SAMPLES-->
        <!-- * -->
        <AudioPlayerCarousel v-if="birds.length" :items="birds" class="relative z-2 mt-16 sm:mt-20" />

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- LIGET AS SHELTER -->
        <!-- * -->
        <div v-if="galleryImages" class="relative mt-16 sm:mt-20 z-1">
            <Type2Block
                title-key="bird_friendly_learning_trail.shelter.title"
                description-key="bird_friendly_learning_trail.shelter.description"
                :images="galleryImages"
                class="relative z-1"
            />

            <TopLocationBackgroundShape4 flip-y class="bottom-20" />
        </div>

        <div class="container mt-16 sm:mt-20">
            <TopLocationProjectPageBanner
                v-if="$t('bird_friendly_learning_trail.event_recommendation_button_url').length && false"
                :button-text="$t('bird_friendly_learning_trail.event_recommendation_button_label')"
                :button-url="$t('bird_friendly_learning_trail.event_recommendation_button_url')"
                label-text-key="bird_friendly_learning_trail.event_recommendation_text"
                type="event"
            />

            <TopLocationProjectPageBanner
                :button-text="$t('bird_friendly_learning_trail.visit_project_button_label')"
                :button-url="$t('bird_friendly_learning_trail.visit_project_button_url')"
                label-text-key="bird_friendly_learning_trail.visit_project_text"
                class="mt-4 sm:mt-8"
            />

            <AwardsBlock
                v-if="awards"
                :title="awards.title"
                :description="awards.description"
                :media="awards.media"
                class="mt-16 sm:mt-20"
            />
        </div>
    </div>
</template>

<script>
import TopLocationProjectPageBanner from '@/components/Pages/TopLocation/TopLocationProjectPageBanner.vue';
import AwardsBlock from '@/components/Blocks/AwardsBlock/AwardsBlock.vue';
import TopLocationHero from '@/components/Pages/TopLocation/Hero/Hero.vue';
import Type3Block from '@/components/Blocks/Type3Block/Type3Block.vue';
import TopLocationBackgroundShape1 from '@/components/Pages/TopLocation/TopLocationBackgroundShape1.vue';
import Type8Block from '@/components/Blocks/Type8Block/Type8Block.vue';
import Type2Block from '@/components/Blocks/Type2Block/Type2Block.vue';
import AudioPlayerCarousel from '@/components/Carousels/AudioPlayerCarousel/AudioPlayerCarousel.vue';
import TopLocationBackgroundShape4 from '@/components/Pages/TopLocation/TopLocationBackgroundShape4.vue';

export default {
    name: 'BirdFriendlyLearningTrail',
    components: {
        AwardsBlock,
        TopLocationProjectPageBanner,
        TopLocationBackgroundShape4,
        AudioPlayerCarousel,
        Type2Block,
        Type8Block,
        TopLocationBackgroundShape1,
        TopLocationHero,
        Type3Block,
    },
    async asyncData({ $axios, i18n }) {
        let birds = [];
        let galleryImages = null;
        let awards = null;

        await Promise.allSettled([
            $axios.$get('/birds'),
            $axios.$get('/galleries/reference/top-location___bird-friendly-learning-trail-1'),
            $axios.$get('/awards/reference/bird-friendly-learning-trail'),
        ])
            .then(([birdsRes, galleriesRes, awardsRes]) => {
                if (birdsRes.status === 'fulfilled') {
                    birds = birdsRes.value.data;
                }

                if (galleriesRes.status === 'fulfilled') {
                    galleryImages = galleriesRes.value.slides;
                }

                if (awardsRes.status === 'fulfilled' && awardsRes.value.is_on_top_locations) {
                    awards = awardsRes.value;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.top_locations'), 'top-locations', true]);
        breadcrumbItems.push([i18n.t('bird_friendly_learning_trail.title'), 'bird-friendly-learning-trail']);

        return {
            birds,
            galleryImages,
            awards,
            breadcrumbItems,
        };
    },
    data() {
        return {};
    },
    head() {
        return {
            title: this.$getPageTitle('top-locations.bird-friendly-learning-trail'),
            meta: this.$getPageMetaData('top-locations.bird-friendly-learning-trail'),
        };
    },
};
</script>

<style scoped></style>
